module.exports = __webpack_public_path__ + "static/media/happiness.2d56ad4f.svg";